import { render, staticRenderFns } from "./CourseQuestionBank.vue?vue&type=template&id=60f919d0&scoped=true&"
import script from "./CourseQuestionBank.vue?vue&type=script&lang=js&"
export * from "./CourseQuestionBank.vue?vue&type=script&lang=js&"
import style0 from "./CourseQuestionBank.vue?vue&type=style&index=0&id=60f919d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f919d0",
  null
  
)

export default component.exports